<template>
  <v-card outlined>
    <v-card-title>
      Occupancy - {{room.text}} <sub>(ID: {{room.value}})</sub>
    </v-card-title>
    <v-divider class="mx-4"/>
    <v-card-text>
      <im-line-chart :chart-data="chart_data" :options="chart_options" :height="250"/>
    </v-card-text>
  </v-card>
</template>

<script>

  export default {

    components: {
      'im-line-chart': () => import('@/components/Statistics/LineChart')
    },

    props: {
      occupancies: Object,
      room: Object
    },

    computed: {

      chart_data() {
        return {
          labels: this.occupancies.labels,
          datasets: [
            {
              label: 'Available',
              data: this.occupancies.datasets.rooms[this.room.value].available,
              borderColor: "#00B0FF",
              backgroundColor: "#00B0FF",
              lineTension: 0
            },
            {
              label: 'Booked',
              data: this.occupancies.datasets.rooms[this.room.value].booked,
              borderColor: "#00E676",
              backgroundColor: "#00E676",
              lineTension: 0
            }
          ]
        }
      },

      chart_options() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          fill: false,
          tooltips: {
            mode: 'index'
          },
          legend: false
        }
      }

    }


  }
</script>